import axios, {AxiosRequestConfig} from 'axios';
import {
  getGlobalAccessToken,
  getGlobalViewKey,
} from './hooks/useGlobalState.client';
import {config} from './config';
import {getViewKeyHeader} from './utils';
import {ClientAnalytics} from '@shopify/hydrogen';

export const axiosClient = axios.create({
  baseURL: config.twlBackendApiBaseUrl,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});

if (import.meta.env.SSR) {
  // - Axios for NodeJS runtime -
  axiosClient.interceptors.request.use(
    (config: AxiosRequestConfig) => config,
    (error) => Promise.reject(error),
  );
} else {
  // - Axios for Browser -
  axiosClient.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      config.headers = {
        ...config.headers,
        ...getViewKeyHeader(getGlobalViewKey()),
      };
      const token = getGlobalAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      const sessionId = ClientAnalytics.getPageAnalyticsData()?.sessionId;
      if (sessionId) {
        config.headers['X-TWL-Session-Id'] = sessionId;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
}

export const axiosReactClient = axios.create({
  baseURL: config.twlReactApiBaseUrl,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});
